
import { getBreakpoint } from 'grommet/utils';

const packageJson = require('../package.json');

export function getVersionString() {
    return packageJson.version;
}

export function getAppName() {
    return `Informační systém historických odrůd révy vinné`;
}

export function getAppNameWithVersion() {
    return `${getAppName()} v${getVersionString()}`;
}

export function getProjectName() {
    return 'DG16P02R017';
}

export function getTileSizeByTheme(theme) {
    let breakpoint = getBreakpoint(window.innerWidth, theme);
    return {
        'large': '192px',
        'medium': '192px',
        'small': '164px'
    }[breakpoint];
}

export function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function vymeraToStringM2(value) {
    return `${value.toLocaleString('cs-CZ')} m2`;
}

export function vymeraToStringHa(value) {
    return `${round(value / 10000, 1).toLocaleString('cs-CZ')} ha`;
}

export function percentToString(value) {
    return `${value.toLocaleString('cs-CZ')}%`;
}
